// A helper for feature chains. Feature chain items can be either:
// 1. LEGACY FORMAT (string): {featureId}:{startType}:{startDelay}:{endType}
// 2. ENHANCED FORMAT (object): { featureId, startType, startDelay, endType, stepLength, componentName }
//
// The enhanced format supports:
// - stepLength: Components spanning multiple steps
// - componentName: Custom component names (defaults to feature name if not provided)
//
// Flow-level metadata (flowName, stepNames) is stored separately in the flow object

export const CHAINS_HELPER = {
    PARAM_INDEXES: {
        FEATURE_ID: 0,
        START_TYPE: 1,
        START_DELAY: 2,
        END_TYPE: 3,
    },
    START_TYPE_AUTO: 'auto',
    START_TYPE_MANUAL: 'manual',
    END_TYPE_FEATURE_END: 'feature_end',
    END_TYPE_IMMEDIATE: 'immediate',
    
    // Parse chain item (handles both legacy string and new object format)
    parseChainItem: (item) => {
        // If already an object, return it with defaults
        if (typeof item === 'object' && item !== null) {
            return {
                featureId: item.featureId,
                startType: item.startType || CHAINS_HELPER.START_TYPE_AUTO,
                startDelay: item.startDelay || 0,
                endType: item.endType || CHAINS_HELPER.END_TYPE_FEATURE_END,
                stepLength: item.stepLength || 1,
                componentName: item.componentName || null,
            };
        }
        
        // Legacy string format: parse it
        if (typeof item === 'string') {
            const parts = item.split(':');
            return {
                featureId: parts[0],
                startType: parts[1] || CHAINS_HELPER.START_TYPE_AUTO,
                startDelay: parseInt(parts[2]) || 0,
                endType: parts[3] || CHAINS_HELPER.END_TYPE_FEATURE_END,
                stepLength: 1, // Legacy items always span 1 step
                componentName: null, // Legacy items use default feature name
            };
        }
        
        return null;
    },
    
    // Serialize chain item for storage (converts object to most efficient format)
    serializeChainItem: (item) => {
        // If it has extended properties, store as object
        if (item.stepLength > 1 || item.componentName) {
            return {
                featureId: item.featureId,
                startType: item.startType,
                startDelay: item.startDelay,
                endType: item.endType,
                stepLength: item.stepLength,
                componentName: item.componentName,
            };
        }
        
        // Otherwise use compact string format for backward compatibility
        return `${item.featureId}:${item.startType}:${item.startDelay}:${item.endType}`;
    },
}
